import {
  StyledRteHtmlText,
  renderRichTextAdvancedNodes,
} from '@framework/engine';
import React, { useMemo } from 'react';
import styled from 'styled-components';

const CoverParagraphText = styled.section`
  &&& {
    ${StyledRteHtmlText};
    font-size: 18px;
    line-height: 1.7;
    margin-bottom: 24px;
  }
`;

export interface IParagraphTextProps {
  text: string | null | undefined;
}

export function ParagraphText(props: IParagraphTextProps) {
  const { text } = props;

  const renderedText = useMemo(() => renderRichTextAdvancedNodes(text), [text]);
  if (!text) return null;

  return <CoverParagraphText>{renderedText}</CoverParagraphText>;
}
